import { InputHTMLAttributes, forwardRef } from 'react';
import search from '~/assets/icons/search.svg';
import { TextInput } from '../TextInput';
import { StyledContainer } from './SearchInput.styled';

const SearchInput = forwardRef<
	HTMLInputElement,
	InputHTMLAttributes<HTMLInputElement> & {
		icon?: string;
		active?: boolean;
		iconStyle?: React.CSSProperties;
		fontSize?: number;
	}
>(({ active, iconStyle, icon, fontSize = 16, ...props }, ref) => {
	return (
		<StyledContainer $active={active}>
			<TextInput
				{...props}
				height={50}
				fontSize={fontSize}
				ref={ref}
				padding="0 44px 0 15px"
			/>
			<img src={icon || search} alt="search" style={iconStyle} />
		</StyledContainer>
	);
});

export { SearchInput };
